import {
  BottomNavigation,
  Button,
  Controller,
  PageModal,
  TextEditor,
  Typography,
  useForm,
} from '@otp/ui';
import { useTranslation } from 'react-i18next';
import React from 'react';

type Form = {
  comment: string;
};

type FileVersionCommentDialogProps = {
  onSubmit: (data?: Form) => void;
  onClose?: () => void;
};

export const FileVersionCommentDialog = ({
  onSubmit,
  onClose,
}: FileVersionCommentDialogProps) => {
  const { t } = useTranslation();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Form>();

  return (
    <PageModal
      open={true}
      onClose={() => onClose?.()}
      title={t('resources.form.comment-dialog.title')}
      fullWidth
    >
      <div className="w-full">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Typography variant="body2" className="mb-4">
            {t('resources.form.comment-dialog.description')}
          </Typography>
          <Controller
            name="comment"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <div>
                <Typography
                  className="mb-2"
                  variant="subtitle1"
                  color={!!errors.comment ? 'red' : ''}
                >
                  {t('resources.form.comment-dialog.title')}
                  <span className="text-red-500"> *</span>
                </Typography>
                <TextEditor {...field} defaultValue={field.value} />
              </div>
            )}
          />
          <BottomNavigation>
            <Button
              type="submit"
              variant="contained"
              className="mr-2"
              color="primary"
              size="medium"
            >
              {t('resources.form.comment-dialog.submit')}
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => onSubmit()}
            >
              {t('resources.form.comment-dialog.cancel')}
            </Button>
          </BottomNavigation>
        </form>
      </div>
    </PageModal>
  );
};
